export class PageControl {
    limit: Number = 10;
    order: string = 'DESC';
    orderField: string;
    page: Number = 0;
    param?: string;
    value?: any;
}

export class ListServices {
    data: Array<any> = [];
    items: Array<any> = [];
    count: number;
    page: number;
    maxPage: number;
}

export class AccountServices {
    data: Array<any> = [];
    items: Array<any> = [];
    count: number;
    page: number;
    maxPage: number;
}

export class UpdatePictureResultHelper {
    success: boolean;
    url: string;
    errorCode: string;
}

export class AutoCompleteHelper {
    id: string;
    name: string;
}
export class AutoCompleteNameHelper {
    name: string;
}

export class DashNumbers {
    totalCities: number;
    totalIndicators: number;
    totalSolutions: number;
    totalSuppliers: number;
}
